import Vue from "vue";
import store from "../store";
import moment from "moment";

const colorMap = {
  'Pendiente': "background: #f0f1f3; color: #637381",
  'Borrador': "background: #f0f1f3; color: #637381",
  'Aprobado': "background: #e8f9f5; color: #13c296",
  'Denegado': "background: #feebeb ; color: #e10e0e",
  'Rechazado': "background: #feebeb ; color: #e10e0e",
  'Autorizado': "background: #edf0ff; color: #3758f9",
  'Enviado': "background: #e8f9f5; color: #13c296",
  'En proceso': "background: #FFFBEB; color: #D97706",
  'Observado': "background: #fffbeb; color: #d97706",
  'Modificado': "background: #d0f0fd; color: #0b76b7",
  'Finalizada': "background: #DCF6EF; color: #13C296",
  'Finalizado': "background: #DCF6EF; color: #13C296",
  'En ejecución': "background: #d0f0fd; color: #0b76b7",
  'Activo': "background: #e8f9f5; color: #13c296",
  'Programado': "background: #fffbeb; color: #d97706",
  'Verificado': "background: #d0f0fd; color: #0b76b7",
  'Enviado a revisión': "background: #F5F3FF; color: #6D28D9",
  'En configuración': "background: #feebeb ; color: #e10e0e",
  'Aprobado SAFI': "background: #edf0ff; color: #3758f9",
  'Aprobado UFI': "background: #CEEFC7; color: #1ABC9C",
  'Cerrado': "background: #f0f1f3; color: #637381",
  'Revisión finalizada': "background: #e8f9f5; color: #13c296",
  'Aprobada RRHH': "background: #E9F7E9; color: #1ABC9C",
  'Enviado a SAFI': "background: #edf0ff; color: #3758f9",
  'Enviado a UFI': "background: #D0F0FD; color: #0B76B7",
  'Cerrada': "background: #f0f1f3; color: #637381",
  'Vigente': "background: #e8f9f5; color: #13c296",
  'Inactivo': "background: #f0f1f3; color: #637381",
  'Asignado': "background: #DBEAFE; color: #101828",
  'Caducado': "background: #feebeb ; color: #e10e0e",
  'Aprobado Hacienda': "background: #cde7e3; color: #13c296",
  'Enviada a Hacienda': "background: #d0f0fd; color: #3c94c8",
  'Observado por Hacienda': "background: #fffbeb; color: #d97706",
  'Distribuido': "background: #e8f9f5; color: #13c296",
  'Por evaluar': "background: #fffbeb; color: #d97706",
  'Incompleto': "background: #fffbeb; color: #d97706",
  'Preaprobado': "background: #e8f9f5; color: #13c296",
  'Programado': "background: #edf0ff; color: #3758f9",

  'Completado': "background: #e8f9f5; color: #13c296",
  'No clasificado': "background: #e8f9f5; color: #13c296",
  'Removido': "background: #f0f1f3; color: #637381",
  'Enviada a Hacienda': "background: #d6effd; color: #3674b5",
  1: "background: #f0f1f3; color: #637381", // Borrador
  4: "background: #f0f1f3; color: #637381", // Pendiente
  6: "background: #fffbeb; color: #d97706", // Observado
  7: "background: #e8f9f5; color: #13c296", // Aprobado
  9: "background: #edf0ff; color: #3758f9", // Autorizado
  10: "background: #FFFBEB; color: #D97706", // En proceso
  12: "background: #d0f0fd; color: #0b76b7", // Modificado
  13: "background: #feebeb ; color: #e10e0e", // Denegado
  5: "background: #feebeb ; color: #e10e0e", // Rechazado
  8: "background: #e8f9f5; color: #13c296", // Enviado
  37: "background: #e8f9f5; color: #13c296", // pre solicitud aprobada

  19: "background: #e8f9f5; color: #13c296", // Finalizada
  30: "background: #feebeb ; color: #e10e0e", // Requerimiento rechazado
  1009: "background: #feebeb ; color: #e10e0e", // Requerimiento rechazado
  29: "background: #005AFF1A; color: #005AFF", // Requerimiento aceptado

  true: "background: #e8f9f5; color: #13c296", // Activo
  false: "background: #feebeb ; color: #e10e0e", // Inactivo
};

Vue.prototype.$colorStatus = (status) => {
  return colorMap[status] || "background: #f0f1f3; color: #637381";
};

Vue.prototype.showLoader = async () => {
  await store.commit("utils/setLoader", true);
};

Vue.prototype.hideLoader = async () => {
  await store.commit("utils/setLoader", false);
};

Vue.prototype.temporalAlert = async (alert) => {
  await store.commit("utils/setAlert", alert);
};
Vue.prototype.hideLoader = async () => {
  await store.commit("utils/setLoader", false);
};

Vue.prototype.validateNotEmojis = (value) => {
  if (value === null) return true;
  return value.match(/(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu) !== null ? false : true;
}

Vue.prototype.restrictIntegerWithOperator = (value) => {
  if (value.charCode >= 48 && value.charCode <= 57) {
    return true;
  } else if (value.charCode === 40 || value.charCode === 41 || value.charCode === 42 || value.charCode === 43 || value.charCode === 45 || value.charCode === 46 || value.charCode === 47) {
    return true;
  } else {
    value.preventDefault();
  }
};

Vue.prototype.isDui = (dui) => {
  if (dui === null) return false;
  let valido = false;

  // Validando la longitud del numero de DUI
  if (dui.length === 10) {
    // Validando que no sea ceros todos los dígitos
    if (dui !== "00000000-0") {
      // Obteniendo los dígitos y el verificador
      let [digitos, validador] = dui.split("-");

      // Verficiando que la cadena
      if (typeof digitos !== "undefined" && typeof validador !== "undefined") {
        // Verificando que el validador sea de un solo caracter
        if (validador.length === 1) {
          // Convirtiendo los digitos a array
          digitos = digitos.split("");

          // Convirtiendo los datos a tipo integer
          validador = parseInt(validador, 10);
          digitos = digitos.map((digito) => parseInt(digito, 10));

          // Obteniendo la suma corresponiente
          let suma = digitos.reduce(
            (total, digito, index) => (total += digito * (9 - index)),
            0
          );

          // Obteniendo el Modulo base 10
          let mod = suma % 10;
          mod = validador === 0 && mod === 0 ? 10 : mod;

          let resta = 10 - mod;

          if (resta === validador) {
            valido = true;
          }
        }
      }
    }
  }
  return valido;
};

Vue.prototype.isNit = (nit) => {
  if (nit === null) return false;

  let valido = false;

  // Validando la longitud del numero de DUI
  if (nit.length === 17) {
    // Validando que no sea ceros todos los dígitos
    if (
      nit !== "0000-000000-000-0" &&
      nit.match(/^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]$/)
    ) {
      // Obteniendo los dígitos y el verificador por separado
      let [ubicacion, fecha, correlativo, validador] = nit.split("-");
      let digitos = (ubicacion + fecha + correlativo).split("");

      // Convirtiendo los datos a tipo integer
      validador = parseInt(validador, 10);
      correlativo = parseInt(correlativo, 10);
      let suma = 0;
      let mod = 0;
      if (correlativo <= 100) {
        // Obteniendo la suma corresponiente
        suma = digitos.reduce(
          (total, digito, index) =>
            (total += parseInt(digito, 10) * (14 - index)),
          0
        );
        // Obteniendo el Modulo base 11
        mod = suma % 11;
        mod = mod === 10 ? 0 : mod;
      } else {
        // Obteniendo la suma corresponiente
        suma = digitos.reduce(
          (total, digito, index) =>
          (total +=
            parseInt(digito, 10) *
            parseInt(3 + 6 * Math.floor((index + 5) / 6) - (index + 1), 10)),
          0
        );
        // Obteniendo el Modulo base 11
        mod = suma % 11;
        mod = mod > 1 ? 11 - mod : 0;
      }
      if (mod === validador) {
        valido = true;
      }
    }
  }
  return valido;
};

Vue.prototype.getPaginationProperties = (response) => {
  return {
    page: Number(response.headers.page),
    per_page: Number(response.headers.per_page),
    total_rows: Number(response.headers.total_rows),
  };
};
//Funcion auxiliar para verificar paths accesibles
const buscarRuta = (rutas, ruta) => {
  return rutas.some((item) => {
    if (item?.childrens?.length > 0)
      if (buscarRuta(item?.childrens, ruta)) return true;

    return item.nombre_uri.toLowerCase() === ruta.name.toLowerCase();
  });
};
//Funcion para verificar las paths accesibles
Vue.prototype.canNext = async (ruta) => {
  //Rutas a las que el usuario siempre va a poder acceder
  const permit = [
    "Forbidden",
    "security",
    "login",
    "forgot-password",
    "reset-password",
    "2fa",
    "verifyMail",
    "Pais",
    "Institucion",
    "EstadoEmpleado",
    "Discapacidad",
    "TipoEstablecimiento",
    "Establecimiento",
    "Departamento",
    "EstadoCivil",
    "FormacionAcademica",
    "Municipio",
    "NivelEducativo",
    "Parentesco",
    "Sexo",
    "TipoDocumento",
    "TipoInstitucion",
    "TipoSangre",
    "InstitucionFinanciera",
    "Pagaduria",
    "TipoAcreedor",
    "Acreedor",
    "Formalizacion",
    "PresupuestoFinancia",
    "SistemaPago",
    "TipoFinanciamiento",
    "CategoriaPlaza",
    "EstadoPlaza",
    "PlazaNominal",
    "EstadoPuestoFuncional",
  ];
  if (!ruta.name) return false;
  //Si la ruta a ingresar esta definida en el arreglo local, permite ingreso
  if (permit.some((row) => row.toLowerCase() === ruta.name.toLowerCase()))
    return true;
  /*Se verifica si la ruta proporcionada se encuentra en las paths
    almacenadas, si no hay entonces se hace la petición para almacenarlas*/
  let { utils } = store.state;
  if (utils.rutas && utils.rutas.length === 0) {
    await store.dispatch("utils/getMenu");
  }
  //Busca ruta en el arreglo de paths
  return buscarRuta(utils.rutas, ruta);
};

Vue.prototype.FormatDatePrt = (date_param, time_param = false) => {
  if (date_param != null) {
    if (time_param) {
      return moment(date_param).format("DD/MM/YYYY HH:mm a");
    } else {
      return moment(date_param).format("DD/MM/YYYY");
    }
  } else {
    return "";
  }
};

Vue.prototype.FormatCurrencyPrt = (value, symbol) => {
  if (value != null) {
    return new Intl.NumberFormat("es-SV", {
      style: symbol ? "currency" : "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currency: "USD",
    }).format(value);
  } else {
    return "";
  }
};

/**
 * Formatea un monto numérico con separador de miles y 2 decimales (1,800.00).
 * Los valores no numéricos ('-', texto) se devuelven tal cual y los vacíos
 * quedan en blanco. No muta el dato original.
 */
Vue.prototype.FormatMontoPrt = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  if (typeof value === "string" && !/^-?\d+(\.\d+)?$/.test(value.trim())) {
    return value;
  }
  const numero = Number(value);
  if (Number.isNaN(numero)) {
    return "";
  }
  return numero.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * clousure para manejar la ejecución buscar (funcion antirebotes)
 * @param Function func
 * @param int timer
 * @return Function
 */
Vue.prototype.debounceTimer = (func, timer = 1000) => {
  let timeout = null;
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func();
    }, timer);
  };
};
Vue.prototype.isValidaMessageError = ($el, nameClass = '.v-messages__message') => {
  const element = $el.querySelector(`${nameClass}:first-of-type`)
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  })
  return;
}


/**
* @method  preventInvalidCharacters
* @description prevenir digitos no permitidos, siempre que no sea la tecla de borrar o suprimir
* @param regex {RegExp} - expresion regular para validar los caracteres permitidos
* @param event {Event} - evento del input
 * @returns {void}
* **/
Vue.prototype.preventInvalidCharacters = (regex, event) => {
  if (!regex.test(event.key) && event.key !== 'Delete' && event.key !== 'Backspace') {
    event.preventDefault();
  }
}

/**
 *
 * @method countCharacters
 * @description limita la cantidad de caracteres en un input
 * @param event {Event} - evento del input
 * @param max {number} - cantidad de caracteres permitidos
 * @returns retorna el valor del input con la cantidad de caracteres permitidos
 */
Vue.prototype.countCharacters = (event, max) => {
  if (event.target.value.length > max) {
    return event.target.value = event.target.value.slice(0, max);
  }
}

/**
 * @method catalogo codigo fases destacamiento
 * @description catálogo de códigos de las diferentes fases de la solicitud destacamiento
 * @return Object
 */
Vue.prototype.destacamientoFase = Object.freeze({
  /**
   * @description Código para la fase UNIDADA: P3-F1
   */
  _UNIDADA: 'P3-F1',

  /**
   * @description Código para la fase JEFATURAA: P3-F2
   */
  _JEFATURAA: 'P3-F2',

  /**
   * @description Código para la fase RRHHA: P3-F3
   */
  _RRHHA: 'P3-F3',

  /**
   * @description Código para la fase TITULARA: P3-F4
   */
  _TITULARA: 'P3-F4',

  /**
   * @description Código para la fase UNIDADB: P3-F5
   */
  _UNIDADB: 'P3-F5',

  /**
   * @description Código para la fase JEFATURAB: P3-F6
   */
  _JEFATURAB: 'P3-F6',

  /**
   * @description Código para la fase RRHHB: P3-F7
   */
  _RRHHB: 'P3-F7',

  /**
   * @description Código para la fase TITULARB: P3-F8
   */
  _TITULARB: 'P3-F8',
});

/**
 * @method catalogo codigo fases de traslado
 * @description catálogo de códigos de las diferentes fases de la solicitud traslado
 * @return Object
 */
Vue.prototype.trasladoFase = Object.freeze({
  /**
   * @description Código para la fase UNIDADA: P7-F1
   */
  _UNIDADA: 'P2-F1',

  /**
   * @description Código para la fase JEFATURAA: P7-F2
   */
  _JEFATURAA: 'P2-F2',

  /**
   * @description Código para la fase RRHHA: P7-F3
   */
  _RRHHA: 'P2-F3',

  /**
   * @description Código para la fase TITULARA: P7-F4
   */
  _TITULARA: 'P2-F4',

  /**
   * @description Código para la fase _DESPACHOBCATCH: P7-F5
   */
  _DESPACHOBCATCH: 'P2-F5',

  /**
   * @description Código para la fase _RRHHBCATCH: P7-F6
   */
  _RRHHBCATCH: 'P2-F6',

  /**
   * @description Código para la fase UNIDADB: P7-F7
   */
  _UNIDADB: 'P2-F7',

  /**
   * @description Código para la fase JEFATURAB: P7-F8
   */
  _JEFATURAB: 'P2-F8',

  /**
   * @description Código para la fase RRHHB: P7-F9
   */
  _RRHHB: 'P2-F9',

  /**
   * @description Código para la fase TITULARB: P7-F10
   */
  _TITULARB: 'P2-F10',
});
